<template>
  <div>
    <!-- Fixed navbar -->
    <b-navbar transparent
              type="is-black"
              :is-active.sync="isNavbarActive"
              fixed-top>

      <!-- Logo, link to home -->
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img
            src="@/assets/logo.png"/>
        </b-navbar-item>
      </template>
      <template slot="start">

        <!-- Links to other pages -->
        <b-navbar-item class="link is-capitalized" tag="router-link" :to="{ path: item.url }"
                      v-for="item in items" :key="item.message">
          {{item.name}}
        </b-navbar-item>

        <!-- Button to open settings modal -->
        <b-navbar-item key="navbar-settings">
          <b-button icon-left="settings"
                    type="is-dark"
                    inverted
                    outlined
                    @click="openSettingsModal"
          >
            Settings
          </b-button>
        </b-navbar-item>
      </template>
    </b-navbar>

    <!-- Settings modal -->
    <b-modal :active.sync="isSettingsModalActive"
                  has-modal-card
                  full-screen
                  trap-focus
                  aria-role="dialog"
                  aria-modal>
      <ModalWrapper title="Settings">
        <Controls />
      </ModalWrapper>
    </b-modal>

  </div>
</template>

<script>
import Controls from '../controls/Controls.vue';
import ModalWrapper from './ModalWrapper.vue';

export default {
  name: 'NavbarMobile',
  components: {
    Controls,
    ModalWrapper,
  },
  data() {
    return {
      items: [{
        url: '/',
        name: 'home',
      }, {
        url: '/about',
        name: 'about',
      }, {
        url: '/credits',
        name: 'credits',
      }],
      isNavbarActive: false,
      isSettingsModalActive: false,
    };
  },
  methods: {
    openSettingsModal() {
      this.isSettingsModalActive = true;
      this.isNavbarActive = false;
    },
  },
};
</script>

<style scoped>
  a.navbar-item {
    color: white;
  }

  .navbar-item {
    background-color: #0a0a0a !important;
  }

  .navbar-item:hover {
    text-decoration: underline;
  }

  .navbar-item.is-active {
    text-decoration: underline;
  }
</style>

<style>
  /* Non-scoped style to fix background color of open burger menu */
  .navbar-menu {
    background-color: #0a0a0a !important;
  }
</style>
